





























































import Draggable from 'vuedraggable';

interface IProp {
  key: string;
  value: string;
}

export default {
  props: {
    title: {
      type: String,
      default: 'Properties',
    },
    value: {
      type: Array,
      default: () => ([] as IProp[]),
    },
  },
  methods: {
    add() {
      this.$emit('input', (
        this.value.concat({
          key: '',
          value: '',
        })
      ));
    },
    remove(index: number) {
      this.$emit('input', [
        ...this.value.slice(0, index),
        ...this.value.slice(index + 1),
      ]);
    },
  },
  computed: {
    localValue: {
      get(): IProp[] {
        return this.value || [];
      },
      set(value: IProp[]) {
        this.$emit('input', value);
      },
    },
  },
  components: {
    Draggable,
  },
} as IView;
